/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Iframe_Remote_Style_Guide_Not_Found_ErrorInputs */

const en_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Style guide with ID "${i?.id}" not found`)
};

const fr_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guide de style avec l'ID "${i?.id}" introuvable`)
};

const de_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Styleguide mit der ID "${i?.id}" nicht gefunden`)
};

const it_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guida di stile con ID "${i?.id}" non trovata`)
};

const ru_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Руководство по стилю с идентификатором "${i?.id}" не найдено`)
};

const es_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se encontró la guía de estilo con ID "${i?.id}"`)
};

const zh_cn2_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`未找到 ID 为“${i?.id}”的样式指南`)
};

const ja_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ID「${i?.id}」のスタイルガイドが見つかりません`)
};

const hi_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आईडी "${i?.id}" वाली स्टाइल गाइड नहीं मिली`)
};

const pt_pt2_iframe_remote_style_guide_not_found_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guia de estilo com ID "${i?.id}" não encontrado`)
};

/**
* | output |
* | --- |
* | "Style guide with ID \"{id}\" not found" |
*
* @param {Iframe_Remote_Style_Guide_Not_Found_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_not_found_error = /** @type {((inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Not_Found_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_style_guide_not_found_error(inputs)
	if (locale === "de") return de_iframe_remote_style_guide_not_found_error(inputs)
	if (locale === "it") return it_iframe_remote_style_guide_not_found_error(inputs)
	if (locale === "ru") return ru_iframe_remote_style_guide_not_found_error(inputs)
	if (locale === "es") return es_iframe_remote_style_guide_not_found_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_style_guide_not_found_error(inputs)
	if (locale === "ja") return ja_iframe_remote_style_guide_not_found_error(inputs)
	if (locale === "hi") return hi_iframe_remote_style_guide_not_found_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_style_guide_not_found_error(inputs)
	return en_iframe_remote_style_guide_not_found_error(inputs)
});